<div *ngIf="loading" class="row">
  <div class="col-md-6 offset-md-2">
    <div style="margin-left: 2rem">
      <span><i class="fa fa-spinner fa-4x fa-pulse"></i></span>
    </div>
  </div>
</div>

<form [hidden]="loading" [formGroup]="userForm">
  <div class="row">
    <div class="col-md-6">
      <p *ngIf="shipUser?.userUuid == ''">
        An active user was not found for this card. You can enable a user for
        this card with the form below
      </p>
      <p *ngIf="shipUser?.userUuid != '' && shipUser?.userUuid != null">
        Active user found for location <strong>{{ shipUser.location }}</strong>
        <br />
        You may update their information with the form below
      </p>
    </div>
  </div>
  <div class="row">
    <div class="col-md-2 zeroPadding">
      <label for="role" class="col-md-12 control-label labelCommon">
        *Role
      </label>
      <div class="form-group col-md-12">
        <select
          class="form-control input-sm"
          formControlName="role"
          (change)="updateLocationStatus($event)"
        >
          <option value="" disabled="disabled" selected name="selected-role">
            Please Select Role
          </option>
          <option
            *ngFor="let role of userRoleValues$ | async"
            [value]="role.name"
          >
            {{ role.name }}
          </option>
        </select>
      </div>
    </div>
    <div class="col-md-3 zeroPadding">
      <label for="location" class="col-md-12 control-label labelCommon">
        Location
      </label>
      <div
        class="form-group col-md-12"
        *ngIf="locationValues$ | async as locations"
      >
        <select class="form-control input-sm" formControlName="location">
          <option
            value=""
            disabled="disabled"
            selected
            name="selected-location"
          >
            Please Select Location
          </option>
          <option disabled="disabled" [value]="NC_SHIP_SUPPORT_LOCATION">
            {{ NC_SHIP_SUPPORT_LOCATION }}
          </option>
          <option
            *ngFor="let location of locations"
            [value]="location.shipLocation"
          >
            {{ location.shipLocation }}
          </option>
        </select>
        <div
          *ngIf="
            userForm.errors?.locationRequired &&
            userForm.get('location').touched
          "
          class="text-danger m-1"
        >
          Location is required for this role
        </div>
      </div>
    </div>

    <div class="col-md-2 zeroPadding">
      <label for="enabled" class="col-md-12 control-label labelCommon">
        Enabled
      </label>
      <div class="form-group col-md-12 m-2">
        <div>
          <input
            formControlName="enabled"
            type="checkbox"
            aria-label="Checkbox for following text input"
          />
        </div>
      </div>
    </div>
  </div>
  <div class="row m-2">
    <div class="col-md-3 offset-md-1">
      <button
        type="submit"
        [disabled]="!userForm.valid"
        id="submitUser"
        (click)="submitUserForm()"
        class="form-group btn btn-nc mr-1"
      >
        SAVE
      </button>
      <button
        id="cancelUserForm"
        (click)="cancelUserForm($event)"
        class="form-group btn btn-nc btn-nc-cancel"
      >
        CANCEL
      </button>
    </div>
  </div>
</form>
